// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"38":"0815c7c1","76":"75ae96ae","88":"e957f32d"}[chunkId] + ".css";
};